import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleStockItemQuantity } from "../redux/productsItems/actions";
import {
  addProductToCart,
  handleCartItemQuantity,
} from "../redux/cartItems/actions";

const ProductItem = ({ product }) => {
  const cartProducts = useSelector((state) => state.cartItems);
  const { id, name, image, category, price, quantity } = product;
  const dispatch = useDispatch();

  // Add to the cart handler ...
  const addToCartHandler = (product, operationType) => {
    let alreadyAdded = cartProducts.find(
      (cartProduct) => cartProduct?.id == product?.id
    );

    alreadyAdded
      ? dispatch(handleCartItemQuantity(product?.id, "plus"))
      : dispatch(addProductToCart(product));
    dispatch(handleStockItemQuantity(product?.id, operationType));
  };

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={image} alt="product Image 404" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{name}</h4>
        <p className="lws-productCategory">{category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{quantity}</span>
          </p>
        </div>
        <button
          className="lws-btnAddToCart"
          disabled={quantity === 0}
          onClick={() => addToCartHandler(product, "minus")}
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
};

export default ProductItem;
